module.exports = __webpack_public_path__ + "img/comfime.a12a83b3.svg";